class CalendarTableEvents {
  constructor(element) {
    this.element = element;
  }

  addEvents(link) {
    let that = this;
    let request = this.#request(link);

    request.onload = function () {
      var list = request.response;
      run(list);
    }

    function run(list) {
      let block = that.element;

      for (let index = 0; index < list.length; index++) {
        const day = list[index];

        if (block.querySelector(`[data-calendar-date="${day.date}"]`)) {
          that.#newDay(day)
        }
      }
    }

    if (window.calendarTable.slider) {
      window.calendarTable.slider.update()
    }
  }

  clearEvents() {
    let block = this.element;
    let list = block.querySelectorAll('.calendar-table__day[data-id]');

    for (let index = 0; index < list.length; index++) {
      const day = list[index];
      this.#clearDay(day);
    }

    if (window.calendarTable.slider) {
      window.calendarTable.slider.update()
    }
  }

  #clearDay(day) {
    day.removeAttribute('data-id');
    let events = day.querySelectorAll('.calendar-table__day-event');
    let buttonAdd = day.querySelector('.calendar-table__day-add');
    let buttonAll = day.querySelector('.calendar-table__day-link');

    buttonAdd.removeAttribute('data-event-add');
    buttonAdd.removeAttribute('data-id');
    buttonAll.remove();

    for (let index = 0; index < events.length; index++) {
      const event = events[index];
      event.remove();
    }
  }

  #newDay(day) {
    let date = day.date;
    let list = this.#sortEventsByTimeStart(day.list);
    let id = day.place_id;
    let block = document.querySelector('.jsCalendarTable');
    let days = block.querySelectorAll(`[data-calendar-date="${date}"]`)

    days.forEach(day => {
      day.setAttribute('data-id', id)
      let dayList = day.querySelector('.calendar-table__day-list');
      let dayActions = day.querySelector('.calendar-table__day-actions');

      let buttonAdd = day.querySelector('.calendar-table__day-add');
      buttonAdd.setAttribute('data-event-add', id);
      buttonAdd.setAttribute('data-id', id);

      let buttonAll = day.querySelector('.calendar-table__day-link') ? day.querySelector('.calendar-table__day-link') : createButtonAll();
      buttonAll.setAttribute('data-event-show', id);
      buttonAll.setAttribute('data-id', id);

      list.forEach((eventData, index) => {
        const eventElement = this.#createEvent(eventData, index);
        dayList.append(eventElement);
      });

      day.querySelectorAll('.calendar-table__day-event').length > 2 ? buttonAll.classList.add('is-visible') : '';

      function createButtonAll() {
        let button;
        let buttonInner = '<span>Все</span>';
        button = document.createElement('button');
        button.classList.add('link', 'calendar-table__day-link');
        button.setAttribute('type', 'button')
        button.innerHTML = buttonInner;
        dayActions.append(button)

        return button;
      }
    })
  }

  #createEvent(eventData, index) {
    const {
      name,
      time,
      type,
    } = eventData;

    let element = document.createElement('div');
    let content = `
			<h4>${name}</h4>
			<span>${time}</span>
		`;
    element.classList.add('calendar-table__day-event');

    if (type === 'request') {
      element.classList.add('_disabled');
    }

    element.setAttribute('style', 'animation-delay:' + (index * 0.1) + 's')
    element.innerHTML = content;

    return element;
  }

  #request(link) {
    let request = new XMLHttpRequest();
    request.open('GET', link);
    request.responseType = 'json';
    request.send();

    return request;
  }

  #sortEventsByTimeStart(events) {
    const result = [...events];
    result.sort((x, y) => x.timestampStart - y.timestampStart);

    return result;
  }
}

export default CalendarTableEvents;
